import { StyledDatagrid } from "@/components/ui/react-admin/StyledDatagrid";
import { ResourceName } from "@/types";
import { getProps } from "@/utils/helpers/columnsHelper";
import { TextField, ListContextProvider, useListController, NumberField } from "react-admin";
import List from "@/components/ui/react-admin/styledList/StyledList";
import { PageHeader } from "@/components/common/PageHeader";
import SecurityIcon from "@mui/icons-material/Security";

export const RolesList = () => {
  const listContext = useListController({ resource: ResourceName.ROLES });
  const { isPending: loading } = listContext;

  return (
    <ListContextProvider value={listContext}>
      <PageHeader customTitle="Roles" headerIcon={<SecurityIcon sx={{ fontSize: 28, color: "primary.main" }} />} />
      <List perPage={50} actions={false} loading={loading}>
        <StyledDatagrid bulkActionButtons={false} rowClick="show">
          <TextField {...getProps("name", ResourceName.ROLES)} />
          <TextField {...getProps("description", ResourceName.ROLES)} />
          <NumberField {...getProps("user_count", ResourceName.ROLES)} />
          <NumberField {...getProps("permission_count", ResourceName.ROLES)} />
        </StyledDatagrid>
      </List>
    </ListContextProvider>
  );
};
